/**
 * Real customer quotes for the homepage. Empty on purpose: the section stays
 * hidden until there are genuine, approved quotes. Never invent or paraphrase
 * one: each entry must be something the person actually said and agreed to
 * have published.
 *
 * Shape:
 * {
 *   quote: 'What they said, in their words.',
 *   name: 'Full name',
 *   role: 'What they do (e.g. "Pastor, Grace Fellowship")',
 *   result: 'Optional concrete outcome (e.g. "1 live → 12 clips, 40 sign-ups")',
 *   photo: '/testimonials/name.jpg',   // optional, in frontend/public
 * }
 */
export const TESTIMONIALS = [];
